/** Shop Phones [START] **/
if(window.productData && window.productData[0] && $('.phone-tile-swipe').length){
  hp.swipers = hp.swipers || {};
  var phone_tile_swipe = 
  {
    initialized: false
  };
  var productDataArr = [];
  phone_tile_swipe.init = function(){
    var productData = window.productData || {};
    if (productData[0] && typeof productData[0].map === 'function') {
      productData[0].map(function (data, index) {
        // console.log('productData',index,data)
        if(!data){return}
        var /*deviceDetailsResponseNew = data.vzwDeviceResponse.deviceDetailsResponse,*/
            /*ray = deviceDetailsResponseNew.skuDetails,*/
            procImageUrl = null,
            badgeText = null,
            badgeToolTip = null,
            prices = null;     
            if(data.imageUrl){//of the four this is compulsory
                procImageUrl = data.imageUrl.replace('$device-lg$', 'hei=445&wid=300');//added now
            }
            if(data.price){
                price = data.price;//added now
            }
            if(data.badgeText){
                badgeText = data.badgeText;//added now
            }
            if(data.badgeToolTip){
                badgeToolTip = data.badgeToolTip;//added now
            }
            if(data.contractTerm){
                contractTerm = data.contractTerm;//added now
            }


  /*        if(ray){
          for(i=0;i<ray.length;i++){
              procImageUrl = ray[i].imageUrl.replace('$device-lg$', 'hei=445&wid=300');
              if(ray[i].selected && data.vzwDeviceResponse.productPriceVO){  
                  var selectedSku = ray[i].deviceSkuId;
                  prices = data.vzwDeviceResponse.productPriceVO.skuPrices[selectedSku].prices;
                  //console.log('obj.selected',index,i)
                  if(prices.Edge && prices.Edge.promoDetails && prices.Edge.promoDetails.promoBadgeMessages && prices.Edge.promoDetails.promoBadgeMessages[0].badgeText){
                     badgeText = prices.Edge.promoDetails.promoBadgeMessages[0].badgeText,
                     badgeToolTip = prices.Edge.promoDetails.promoBadgeMessages[0].badgeToolTip;
                     //console.log('---',selectedSku,badgeText.length);
                  }      
                  break;
              }
          }
        }*/
        productDataArr.push({
          brandName: data.brandName,//added now
          /*brandName: deviceDetailsResponseNew.brandName,*/
          modelName: data.displayName,//added now
          /*modelName: deviceDetailsResponseNew.displayName,*/
          imageUrl:  procImageUrl,//same in both cases
          canonicalUrl: data.canonicalUrl, //added now
          seoUrlName: data.seoUrlName
         /* canonicalUrl: deviceDetailsResponseNew.seo.canonicalUrl *///,
         // badgeText: badgeText,
         // badgeToolTip: badgeToolTip
         
         
         // price: data.vzwDeviceResponse.deviceDetailsResponse.skuDetails[0].devicePrice[0].contractPrice,
         // contractTerm: data.skuDetails[0].devicePrice[0].contractTerm, 
         
        });   
        
         /* END OF SERVICE CODE SWITCH */
        
        
        
      });


      var girdPhoneTileID = ".phoneTile";
      var girdAccessoryTileID = "#accessoryTiles";

      if ($(girdPhoneTileID) && $(girdPhoneTileID).length && $(girdPhoneTileID).length > 0) {
        populateTileGrid(girdPhoneTileID);
      }
      if ($(girdAccessoryTileID) && $(girdAccessoryTileID).length && $(girdAccessoryTileID).length > 0) {
        populateTileGrid(girdAccessoryTileID);
      }
      
      $('.swiper-slide.phone-tile').each(function(){
        // console.log($(this).find('.shop-phones-badge-heading>a').text())
        if(!$(this).find('.shop-phones-badge-heading>a').text().length){
          $(this).find('.shop-phones-badge-heading').remove();
        }
      });
      
    }
    // Shop Phones Tiles Swiper
    var phoneTileProps = {
      pagination: {
        el: '.phone-tile-pagination',
        type: 'bullets',
        clickable: true,
      },
      lazy: false,
      slidesPerView: 3,
      spaceBetween: 0,
      loop: false,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 0
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    }
    var phoneTileMethods = {
      onlyMobileSwipe: true,
      resizeHandler: true,
      a11ySwiper: true,
	    swiperEvents: [{
        eventName: "slideChangeTransitionEnd",
        eventMethod: function () {
          hp.modifyAriaLabel()
					hp.hideMobileSlidesNotInView()
					window.focusHeading && window.focusHeading.focus()
        }
      }]
    }
    hp.swipers.phone_tile_swipe.instances = hp.swiperInstance('.phone-tile-swipe', phoneTileProps, phoneTileMethods);
    hp.swipers.phone_tile_swipe.initialized = true;
  }//END init


  function populateTileGrid(gridID) {
    for (var i = 0; i < ($(gridID + " .shop-phones-grid-heading").length); i++) {
      if (productDataArr[i]) {
        $($(gridID + " .brandName")[i]).parent().attr({"href":"/"+productDataArr[i].canonicalUrl});//,"sitecat-datatrack":productDataArr[i].seoUrlName
        //$($(gridID + " .shop-phones-image-frame a")[i]).attr({"href":"/"+productDataArr[i].canonicalUrl});//,"sitecat-datatrack":productDataArr[i].seoUrlName
        $($(gridID + " .brandName")[i]).html(productDataArr[i].brandName)
        $($(gridID + " .modelName")[i]).html(productDataArr[i].modelName)
        $($(gridID + " .shop-phones-badge-heading a")[i]).attr({"href":"/"+productDataArr[i].canonicalUrl});//,"sitecat-datatrack":productDataArr[i].seoUrlName
        // $($( gridID + " .productPrice")[i]).html("$" + productDataArr[i].price + "/mo")
        $($(gridID + " .shop-phones-image-frame")[i]).find("img").attr("data-src", productDataArr[i].imageUrl);
        //$($(gridID + " .shop-phones-image-frame")[i]).find("img").attr("src", productDataArr[i].imageUrl);
        $($(gridID + " .shop-phones-image-frame")[i]).find("img").attr("alt", productDataArr[i].brandName + ", " + productDataArr[i].modelName);
        if (productDataArr[i].discountedPrice) {
          // $($( gridID + " .productPrice")[i]).addClass("strikeThrough");
          // $($( gridID + " .discountedPrice")[i]).html("$" + productDataArr[i].discountedPrice + "/mo")
        }
        if (productDataArr[i].badgeText && !$('.swiper-slide.phone-tile:eq('+ i +') .phoneBadge').length) {
          $('.swiper-slide.phone-tile:eq('+ i +')').prepend('<div class="phoneBadge">'+ productDataArr[i].badgeText +'</div>');
          if(productDataArr[i].badgeToolTip){
            $('.swiper-slide.phone-tile:eq('+ i +') .phoneBadge').append('<span class="a11y-tooltip"><span class="a11y-hidden">'+ productDataArr[i].badgeToolTip +'</span></span>');
          }
          //console.log('badge',gridID)
        }
      }
    }
    $('.swiper-slide.phone-tile .shop-phones-image-frame img').off('click').on('click',function(){
     	location.href = $(this).parents('.swiper-slide.phone-tile').find('.shop-phones-grid-heading a').attr('href')
		})
  }

  hp.swipers.phone_tile_swipe = phone_tile_swipe;
}
/** Shop Phones [END] **/
